/**
 * Hero Print Slider — stacked slides + invitation open animation
 */
import Alpine from 'alpinejs';

export default function heroPrintSlider(slides = []) {
    return {
        slides,
        current: 0,
        opened: false,
        revealReady: false,
        autoplayTimer: null,
        progress: 0,
        progressTimer: null,
        autoplayMs: 5000,

        init() {
            if (this.slides.length < 2) return;
            this.startAutoplay();
        },

        get activeSlide() {
            return this.slides[this.current] ?? this.slides[0];
        },

        slideOffset(index) {
            const total = this.slides.length;
            return (index - this.current + total) % total;
        },

        slideStyle(index) {
            const offset = this.slideOffset(index);
            const presets = [
                { z: 30, rot: -1,  y: 0,  scale: 1,    opacity: 1,   w: '86%', h: '80%', top: '12%', left: '7%' },
                { z: 20, rot: 4,   y: 10, scale: 0.97, opacity: 1,   w: '82%', h: '76%', top: '10%', left: '9%' },
                { z: 10, rot: -7,  y: 20, scale: 0.94, opacity: 0.95, w: '78%', h: '72%', top: '8%',  left: '11%' },
                { z: 5,  rot: 5,   y: 28, scale: 0.91, opacity: 0.85, w: '74%', h: '68%', top: '6%',  left: '13%' },
            ];
            const p = presets[offset] ?? presets[presets.length - 1];

            return `
                z-index: ${p.z};
                width: ${p.w};
                height: ${p.h};
                top: ${p.top};
                left: ${p.left};
                transform: rotate(${p.rot}deg) translateY(${p.y}px) scale(${p.scale});
                opacity: ${p.opacity};
            `;
        },

        goTo(index) {
            if (this.opened || index === this.current) return;
            this.current = index;
            this.resetAutoplay();
        },

        next() {
            if (this.opened) return;
            this.current = (this.current + 1) % this.slides.length;
            this.resetAutoplay();
        },

        prev() {
            if (this.opened) return;
            this.current = (this.current - 1 + this.slides.length) % this.slides.length;
            this.resetAutoplay();
        },

        openSlide(index) {
            this.current = index;
            this.stopAutoplay();
            this.opened = true;
            this.revealReady = false;
            document.body.classList.add('overflow-hidden');

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.revealReady = true;
                });
            });
        },

        closeSlide() {
            this.revealReady = false;
            setTimeout(() => {
                this.opened = false;
                document.body.classList.remove('overflow-hidden');
                this.startAutoplay();
            }, 650);
        },

        startAutoplay() {
            this.stopAutoplay();
            if (this.slides.length < 2) return;

            this.progress = 0;
            const tick = 50;
            this.progressTimer = setInterval(() => {
                this.progress = Math.min(100, this.progress + (tick / this.autoplayMs) * 100);
            }, tick);

            this.autoplayTimer = setInterval(() => {
                this.next();
                this.progress = 0;
            }, this.autoplayMs);
        },

        stopAutoplay() {
            clearInterval(this.autoplayTimer);
            clearInterval(this.progressTimer);
            this.autoplayTimer = null;
            this.progressTimer = null;
        },

        resetAutoplay() {
            this.stopAutoplay();
            this.progress = 0;
            this.startAutoplay();
        },

        destroy() {
            this.stopAutoplay();
            document.body.classList.remove('overflow-hidden');
        },
    };
}

Alpine.data('heroPrintSlider', heroPrintSlider);
